import type { MessageId } from "@domain/intl/useTranslation";

import type { AgentStepId } from "./runner/types";

export type AgentPhaseId = "prepare" | "documents" | "bank" | "bookings" | "review";

export interface AgentPhase {
    id: AgentPhaseId;
    labelId: MessageId;
    steps: AgentStepId[];
}

/** The five phases of the stepper; every step belongs to exactly one (a test pins it). */
export const AGENT_PHASES: AgentPhase[] = [
    { id: "prepare", labelId: "app.agent.phase.prepare", steps: ["start", "upload"] },
    {
        id: "documents",
        labelId: "app.agent.phase.documents",
        steps: ["aiReading", "aiRetry", "autoSort", "sortQuestions", "documentContacts", "kasseFromDocuments"],
    },
    { id: "bank", labelId: "app.agent.phase.bank", steps: ["bankImport", "bankContacts"] },
    {
        id: "bookings",
        labelId: "app.agent.phase.bookings",
        steps: ["draftsFromDocuments", "draftsFromTransactions", "fillBank", "reconcile"],
    },
    { id: "review", labelId: "app.agent.phase.review", steps: ["aiCheck", "postingRules", "report"] },
];
